import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { HalalBadge } from "@/components/HalalBadge";

function formatErr(detail) {
  if (!detail) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Auth() {
  const navigate = useNavigate();
  const { login, register } = useApp();
  const [tab, setTab] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = tab === "login"
        ? await login(form.email, form.password)
        : await register({ name: form.name, email: form.email, password: form.password, phone: form.phone || null });
      toast.success(tab === "login" ? "Velkommen tilbage!" : "Konto oprettet!");
      navigate(u.role === "admin" ? "/admin" : "/konto");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16 lux-rise">
      <img src="/brand/logo.png" alt="BARE 1 MERE" className="mb-4 h-20 w-20 rounded-full pink-glow" />
      <HalalBadge size="sm" />
      <div className="mt-6 w-full rounded-3xl border border-border/70 bg-card p-6 lux-shadow">
        <div className="mb-6 flex rounded-full border border-border p-1">
          <button onClick={() => setTab("login")} data-testid="tab-login" className={`flex-1 rounded-full py-2 text-sm font-semibold transition-all ${tab === "login" ? "bg-primary text-primary-foreground" : ""}`}>Log ind</button>
          <button onClick={() => setTab("register")} data-testid="tab-register" className={`flex-1 rounded-full py-2 text-sm font-semibold transition-all ${tab === "register" ? "bg-primary text-primary-foreground" : ""}`}>Opret konto</button>
        </div>
        {error && <div className="mb-4 rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-2 text-sm text-destructive" data-testid="auth-error">{error}</div>}
        <form onSubmit={submit} className="space-y-3">
          {tab === "register" && (
            <input required value={form.name} onChange={set("name")} placeholder="Fulde navn" data-testid="auth-name" className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" />
          )}
          <input required type="email" value={form.email} onChange={set("email")} placeholder="E-mail" data-testid="auth-email" className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" />
          {tab === "register" && (
            <input value={form.phone} onChange={set("phone")} placeholder="Telefon (dansk, valgfrit)" data-testid="auth-phone" className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" />
          )}
          <input required type="password" value={form.password} onChange={set("password")} placeholder="Adgangskode" data-testid="auth-password" className="w-full rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" />
          <button disabled={loading} data-testid="auth-submit" className="gloss w-full rounded-full bg-primary py-3.5 font-bold text-primary-foreground transition-transform hover:scale-[1.02] disabled:opacity-60">
            {loading ? "Vent…" : tab === "login" ? "Log ind" : "Opret konto"}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-muted-foreground">Social login (Google/Apple) kommer snart.</p>
      </div>
      <Link to="/" className="mt-6 text-sm text-muted-foreground hover:text-primary">← Tilbage til shoppen</Link>
    </div>
  );
}
